import AddressComponent from './AddressComponent';

export default AddressComponent;
